import api from 'helpers/api';

export function fetchPaymentMethodAuthorizationToken(
  customerId,
  authorizationToken
) {
  return api.backend
    .get('payment_methods/new', {
      params: {
        customer_id: customerId,
        update_payment_method_token: authorizationToken,
        provider: 'braintree'
      }
    })
    .then(response => response.data.paymentMethod.token);
}

export function updatePaymentMethod(
  customerId,
  updatePaymentMethodToken,
  authorizationToken,
  nonce
) {
  return api.backend.post('payment_methods', {
    customer_id: customerId,
    update_payment_method_token: updatePaymentMethodToken,
    provider: 'braintree',
    payment_method: {
      nonce,
      token: authorizationToken
    }
  });
}



// WEBPACK FOOTER //
// ./src/api/payment-methods.js